<!-- <div id="clientList" class="card">

    <div class="card-body ">
        <div class="row g-3">
            <div class="col-md-6">
                <div *ngIf="this.entityId && this.entityId !=''" class="d-flex align-items-center gap-2 ">
                    <div class="search-box flex-grow-1">
                        <input type="text" name="searchTerm" class="form-control search bg-light border-light"
                            placeholder="Search by file name" [(ngModel)]="fileManagementService.searchTerm">
                        <i class="ri-search-line search-icon"></i>
                        <i class="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                            *ngIf="fileManagementService.searchTerm && fileManagementService.searchTerm.length >0"
                            style="font-size: 1rem;
                                    position: absolute;
                                    cursor: pointer;
                                    right: 13px;
                                    top: 0;
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    color: #878a99;" (click)="clearSearch(fileManagementService)"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-auto ms-auto">
                <div class="d-flex align-itdisabledems-center gap-2">
                    <button [disabled]="" class="btn btn-success createFile-modal " data-bs-toggle="modal"
                        data-bs-target="#createFileModal" (click)="addFiles()">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        <span i18n="@@"> Add </span>
                    </button>
                    <div *ngIf="this.entityId && this.entityId !=''" class="d-flex gap-2">
                        <button *ngIf="checkedValGet.length !=0" class="btn btn-primary add-btn"
                            (click)="batchDownload(checkedValGet)">
                            <i class='bx bx-download'></i>
                            <span i18n="@@"> Download Selected</span>
                        </button>
                        <button *ngIf="checkedValGet.length !=0" class="btn btn-primary add-btn"
                            (click)="batchDelete(checkedValGet)">
                            <i class="bx bx-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body p-0">

        <div
            style="padding-right: 1rem; padding-left: 1rem; overflow: scroll; margin-bottom: 0; scrollbar-width: none; ">
            <div class="table-responsive table-card " style="margin-bottom: 0; margin-top: 0; overflow-y: hidden; ">
                <table class="table align-middle table-nowrap" style="margin-bottom: 0;">

                    <thead class="text-muted table-light">
                        <tr>
                            <th scope="col" style="width: 50px;">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="checkAll" value="option"
                                        style="cursor:pointer" [(ngModel)]="masterSelected"
                                        (change)="checkUncheckAll($event,listItems)">
                                </div>
                            </th>
                            <th scope="col" style="width:40%">
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Name</span>
                                    <div class="flex-shrink-0 " style="cursor:pointer">
                                        <div *ngIf='sortBy != enumFileManagementSortBy.NameAsc && sortBy != enumFileManagementSortBy.NameDesc'
                                            class="bx bxs-sort-alt me-1"
                                            (click)="sort(enumFileManagementSortBy.NameAsc)"></div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.NameAsc'
                                            class="bx bx-caret-up me-1"
                                            (click)="sort(enumFileManagementSortBy.NameDesc)">
                                        </div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.NameDesc'
                                            class="bx bx-caret-down me-1" (click)="sort(enumFileManagementSortBy.None)">
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">File Item</span>
                                    <div class="flex-shrink-0 " style="cursor:pointer">
                                        <div *ngIf='sortBy != enumFileManagementSortBy.FileItemAsc && sortBy != enumFileManagementSortBy.FileItemDesc'
                                            class="bx bxs-sort-alt me-1"
                                            (click)="sort(enumFileManagementSortBy.FileItemAsc)"></div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.FileItemAsc'
                                            class="bx bx-caret-up me-1"
                                            (click)="sort(enumFileManagementSortBy.FileItemDesc)">
                                        </div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.FileItemDesc'
                                            class="bx bx-caret-down me-1" (click)="sort(enumFileManagementSortBy.None)">
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">File Size</span>
                                    <div class="flex-shrink-0 " style="cursor:pointer">
                                        <div *ngIf='sortBy != enumFileManagementSortBy.FileSizeAsc && sortBy != enumFileManagementSortBy.FileSizeDesc'
                                            class="bx bxs-sort-alt me-1"
                                            (click)="sort(enumFileManagementSortBy.FileSizeAsc)"></div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.FileSizeAsc'
                                            class="bx bx-caret-up me-1"
                                            (click)="sort(enumFileManagementSortBy.FileSizeDesc)">
                                        </div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.FileSizeDesc'
                                            class="bx bx-caret-down me-1" (click)="sort(enumFileManagementSortBy.None)">
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Modified Date</span>
                                    <div class="flex-shrink-0 " style="cursor:pointer">
                                        <div *ngIf='sortBy != enumFileManagementSortBy.UploadDateAsc && sortBy != enumFileManagementSortBy.UploadDateDesc'
                                            class="bx bxs-sort-alt me-1"
                                            (click)="sort(enumFileManagementSortBy.UploadDateAsc)"></div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.UploadDateAsc'
                                            class="bx bx-caret-up me-1"
                                            (click)="sort(enumFileManagementSortBy.UploadDateDesc)">
                                        </div>
                                        <div *ngIf='sortBy == enumFileManagementSortBy.UploadDateDesc'
                                            class="bx bx-caret-down me-1" (click)="sort(enumFileManagementSortBy.None)">
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Actions</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="list form-check-all">

                        <tr *ngFor="let data of listItems ; index as i" id="i_{{data.id}}">
                            <td scope="row">
                                <div class="form-check">
                                    <input id="checkboxId" class="form-check-input" type="checkbox" name="checkAll"
                                        style="cursor:pointer" (click)="stopPropagationOnClick($event)"
                                        value="{{data.id}}" (change)="onCheckboxChange($event, listItems)"
                                        [(ngModel)]="data.state">
                                </div>
                            </td>
                            <td>
                                <ngb-highlight style="cursor:default" [result]="renameLength(data.fileName)"
                                    [term]="fileManagementService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight style="cursor:default" [result]="data.fileType"
                                    [term]="fileManagementService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight style="cursor:default" [result]="renameFileSize(data.fileSize)"
                                    [term]="fileManagementService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight style="cursor:default" [result]="dateRename(data.createdDate)"
                                    [term]="fileManagementService.searchTerm">
                                </ngb-highlight>
                            </td>
                            <td>
                                <div class=" d-flex ">
                                    <i *ngIf="this.entityId && this.entityId !='' && (viewableExtensions.indexOf(data.fileExt) > -1) else elseViewSpacing"
                                        class="ri-eye-fill align-bottom me-2 text-muted fs-17" style="cursor: pointer;"
                                        (click)="viewDocument(data)"></i>
                                    <ng-template #elseViewSpacing>
                                        <div style="width: 1.6rem;"></div>
                                    </ng-template>
                                    <i *ngIf="(this.entityId && this.entityId !='') else elseDownloadSpacing"
                                        class="ri-download-2-line align-bottom me-2 text-muted fs-20"
                                        style="cursor: pointer;" (click)="download(data)"></i>
                                    <ng-template #elseDownloadSpacing>
                                        <div style="width: 1.6rem;"></div>
                                    </ng-template>
                                    <ul class="list-inline hstack gap-2 mb-0">
                                        <li class="list-inline-item">
                                            <div class="dropdown" ngbDropdown style="z-index: 100;  position: static;">
                                                <button *ngIf="(this.entityId && this.entityId !='')"
                                                    class="btn btn-soft-secondary btn-sm dropdown arrow-none"
                                                    type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                                    ngbDropdownToggle>
                                                    <i class="ri-more-fill align-middle"></i>
                                                </button>
                                                <ul class="dropdown-menu " ngbDropdownMenu
                                                    style=" position: absolute; ">
                                                    <li
                                                        *ngIf="(this.entityId && this.entityId !='')  && (viewableExtensions.indexOf(data.fileExt) > -1)">
                                                        <a class="dropdown-item" href="javascript:void(0);"
                                                            (click)="viewDocument(data)" style="cursor: pointer;">
                                                            <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                            View</a>
                                                    </li>
                                                    <li *ngIf="this.entityId && this.entityId !=''"><a
                                                            class="dropdown-item edit-item-btn" data-bs-toggle="modal"
                                                            (click)="download(data)" style="cursor: pointer;">
                                                            <i
                                                                class="ri-download-2-line align-bottom me-2 text-muted"></i>
                                                            Download</a></li>
                                                    <li>
                                                        <a class="dropdown-item remove-item-btn" data-bs-toggle="modal"
                                                            (click)="deleteData(data.id)" style="cursor: pointer;">
                                                            <i
                                                                class="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                            Delete
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>
        </div>
    </div>

    <div class=" card-body ">
        <div class="row justify-content-md-between align-items-md-center">
            <div class="col col-sm-6">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{pagingInfo(fileManagementService)}}
                </div>
            </div>
            <div class="col col-sm-6">
                <div class="text-sm-right float-end listjs-pagination">
                    <ngb-pagination [collectionSize]="(total | async)!" [(page)]="fileManagementService.startIndex">
                        <ng-template ngbPaginationPages let-page let-pages="pages">
                            <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                                <div class="mb-3 d-flex flex-nowrap px-2">
                                    <label id="paginationInputLabel" for="paginationInput"
                                        class="col-form-label me-2 ms-1" i18n="@@Pagination_Text_Page">Page</label>
                                    <input #i type="text" inputmode="numeric" pattern="[0-9]*"
                                        class="form-control custom-pages-input" id="paginationInput"
                                        [value]="fileManagementService.startIndex"
                                        (keyup.enter)="selectPage(fileManagementService,i.value)"
                                        (blur)="selectPage(fileManagementService,i.value)"
                                        (input)="formatPageInput($any($event).target)"
                                        aria-labelledby="paginationInputLabel paginationDescription"
                                        style="text-align: center; width:3.5rem;" />
                                    <span id="paginationDescription" class="col-form-label text-nowrap px-2 ">
                                        <span i18n="@@Pagination_Text_Of">of</span> {{pages.length}}</span>
                                </div>
                            </li>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoadingVal" id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

</div> -->

<div  class="card">
    <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="fileManagementService"
    [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"  (updateCheckedValues)="checkedValGet =  $event"
    (rowActionSelected)="rowActionSelected($event)" (filterSelected)="filterSelected($event)"
    (sortSelected)="sortByPassedSort($event)"
    (resetListLayout) = "fileManagementService.resetListState($event)"
    (searchTermChanged)="fileManagementService.searchTerm = $event"
    (paginationSelected)="paginationUpdated(fileManagementService,$event)" [serviceData]="serviceData"
    (pageSizeSelected) = "fileManagementService.pageSize = $event"
    ></app-list-layout>
</div>
